export default function ParentPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        👶 Mis Hijos
      </h1>
      <p style={{ color: '#888' }}>Portal para padres pendiente de implementación.</p>
    </div>
  );
}
